import type { ExperimentalQueries } from '../__types__/ExperimentalQueries'; //eslint-disable-line no-restricted-imports
import { MediaType } from '../MediaType';

export const experimentalAnalyticsSearchCountGroupBySpace: ExperimentalQueries['experimentalAnalyticsSearchCountGroupBySpace'] =
	(_, { cloudId, fromDate, toDate, limit, searchTerm, sortOrder }, { network }) => {
		const body = {
			startTime: fromDate,
			endTime: toDate,
			limit,
			searchTerm,
			eventName: ['quickSearchResult_selected', 'advancedSearchResultLink_clicked'],
			sortOrder,
		};

		const url = `/gateway/api/ex/confluence/${cloudId}/analytics/v1/search/count/groupBy/space`;

		return network
			.cfetch(url, {
				method: 'POST',
				credentials: 'include',
				headers: {
					'Content-Type': MediaType.JSON,
				},
				body: JSON.stringify(body),
			})
			.then((response) => response.json())
			.then((responseJson) => {
				return responseJson;
			});
	};
